import { BLUR_REVERSE_MAP } from 'features/virtual-backgrounds/blurValueMap';
import {
  SelectedVirtualBackground,
  VirtualBackgroundItem,
} from 'features/virtual-backgrounds/types';

export const vbConfigToSDKState = (
  config: SelectedVirtualBackground,
  backgrounds: VirtualBackgroundItem[]
) => {
  const { type, value } = config;

  if (!(type && value)) {
    return {
      enabled: false,
    };
  }

  const matchingBackground = backgrounds.find((background) => background.value === value);
  if (matchingBackground) {
    return {
      enabled: true,
      type: matchingBackground.type,
      name: matchingBackground.id,
      // @TODO return matchingBackground directly in the future
      // Maintain backward compatibility by preserving the object structure
      value: {
        src:
          matchingBackground.type === 'blur'
            ? (BLUR_REVERSE_MAP[matchingBackground.value] ?? matchingBackground.value)
            : matchingBackground.value,
        thumb: matchingBackground.thumbnail,
        alt: matchingBackground.label,
      },
    };
  }

  // No predefined match. A blur is still a blur even without a preset match;
  // only unmatched image/video selections are treated as custom URLs.
  let resolvedType = 'imageUrl';
  if (type === 'blur') {
    resolvedType = 'blur';
  } else if (type === 'video') {
    resolvedType = 'videoUrl';
  }

  return {
    enabled: true,
    type: resolvedType,
    value: {
      src: config.value,
      thumb: config.thumbnail,
      alt: config.label,
    },
  };
};
